import { ButtonMui } from 'src/components/ButtonMui/ButtonMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.4rem;
  max-width: 100%;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const SubtitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 30px;
`

export const ButtonsContainer = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  gap: 40px;
`

export const CustomButton = styled(ButtonMui)`
    width: 15rem;    
    height: 2.5rem !important;
    margin: 0 !important;
`
